import * as angular from 'angular';
import * as d3 from 'd3';

import Chart from './modelQualityAnalysis.chart';
import { ComponentDefinition } from '../../models';

class ModelQualityAnalysisController implements angular.IComponentController {
    isLoading: boolean;
    data: any;

    private _columns = ['', 'Measured', 'Calculated', 'Validated', 'States'];
    private _chart: Chart;
    static $inject = ['$element', '$state', '$translate'];


    constructor(private _element: any,
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService) {
    }

    $onInit() {
        const container = d3.select(this._element[0]).select('.chart');
        const columns = this._columns.map(c => this._$translate.instant(c));
        this._chart = new Chart(container, columns).onClick((d: any) => {
            this._$state.go('group.general', { groupGuid: d.group.guid });
        });
        this.update();
    }

    $onChanges(changesObj) {
        if (changesObj['data'] || changesObj['groups'] || changesObj['states']) {
            this.update();
        }
    }

    private update() {
        if (this.data && this._chart) {
            this._chart.update(this.data);
        }
    }
}

export const wtModelQualityAnalysis: ComponentDefinition = {
    componentId: 'wtModelQualityAnalysis',
    controller: ModelQualityAnalysisController,
    template: require('./ModelQualityAnalysis.component.html'),
    controllerAs: 'vm',
    bindings: {
        data: '<',
        isLoading: '<',
        loadingMessage: '<'
    }
};
